if (!customElements.get('diamond-ring-actions')) {
  window.DiamondRingsActions = class DiamondRingsActions extends DiamondActions {
    constructor() {
      super();
      this.handle = this.dataset.handle;
      this.submitBtn = this.querySelector('[data-action="select"]');
      window.journey_start_with = window.journey_start_with || 'setting';
      const tracker = document.querySelector('[data-journey-start-with]');
      this.cartAttributes = this.getAttribute('data-cart-attributes');
      const submitRingLink =
        document.querySelector('.journey-tracker__step-link[data-action="submit-ring"]');
      if (submitRingLink && window.theme.template == 'product') {
        console.log('submitRingLink', submitRingLink);
        submitRingLink.addEventListener('click', this.submit.bind(this));
      }
      if (tracker) {
        const startWith = tracker.dataset.journeyStartWith;
        if (startWith) window.journey_start_with = startWith;
      }

      try {
        Object.defineProperty(String.prototype, 'capitalize', {
          value: function () {
            return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
          },
          enumerable: false,
        });
      } catch (e) {}
    }

    capitalize(str) {
      return (str.charAt(0)?.toUpperCase() || '') + (str.slice(1)?.toLowerCase() || '');
    }

    async submit(event) {
      if (event?.preventDefault) event.preventDefault();
      const form = this.closest('.product-form');
      const idInput = form.querySelector('[name="id"]');
      const shapeInput = form.querySelector('[data-option-name="Shape"] input:checked');
      const metalInput = form.querySelector('[data-option-handle="metal"] input:checked');
      const variant_id = idInput ? idInput.value : null;
      const shape = (shapeInput ? shapeInput.value : 'round').replaceAll(' ', '_').toLowerCase().trim();
      const shapeCollectionUrl = window[`${shape}_collection_url`];
      const fingerSize = form.querySelector(`.cc-select__option[aria-selected="true"]`)?.dataset?.value;
      if (!variant_id) return console.log('no variant_id');
      const attributes = {
        ring_handle: this.handle,
        ring_shape: shape.toUpperCase() || 'ROUND',
        ring_metal: this.capitalize(metalInput?.value || ''),
        ring_variant_id: variant_id,
        ring_Finger_size: fingerSize,
        ring_timestamp: Date.now(),
      };
      if (window.journey_start_with === 'setting') {
        attributes.rings_collection_url = window.rings_collection_url;
      }
      if (window.journey_start_with_fullback) {
        attributes.journey_start_with = window.journey_start_with_fullback;
      } else if (!attributes.journey_start_with) {
        attributes.journey_start_with = window.journey_start_with;
      }

      try {
        DiamondActions.showOverlay({ msg: `Preparing your ring ...` });
        const cart = await DiamondActions.updateCartAttrs({ attributes });
        const ring_shape_down = cart.attributes.ring_shape?.toLowerCase().replaceAll(' ', '_');
        const diamond_shape_down = cart.attributes.diamond_shape?.toLowerCase().replaceAll(' ', '_');
        const url = this.dataset.diamond === 'natural' ? window.natural_search_page_url : window.lapgrown_search_page_url;

        if (ring_shape_down == diamond_shape_down && cart.attributes.diamond_handle) {
          return (window.location.href = window.complete_engagement_ring_url);
        } else if (ring_shape_down !== diamond_shape_down && diamond_shape_down) {
          return (window.location.href = url + `?journey_start_with=${window.journey_start_with}`);
        }
        if (window.journey_start_with === 'diamond') return (window.location.href = window.complete_engagement_ring_url);
        window.location.href = url + `?journey_start_with=setting`;
      } catch (error) {
        console.error('error', error);
        DiamondActions.hideOverlay();
        if (error.message === 'Failed to update cart after multiple attempts' || error.message.includes('Load failed')) {
          alert("We're having trouble processing your request. Please try again in a moment.");
        } else {
          alert(error.message || 'An unexpected error occurred. Please try again.');
        }
      }
    }
  };

  window.customElements.define('diamond-ring-actions', DiamondRingsActions);
}
